import { render, staticRenderFns } from "./ManagementView.vue?vue&type=template&id=c41ff4bc&scoped=true&"
import script from "./ManagementView.vue?vue&type=script&lang=ts&"
export * from "./ManagementView.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementView.vue?vue&type=style&index=0&id=c41ff4bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41ff4bc",
  null
  
)

export default component.exports